











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamInvitationEmailCreateAccount_verifiedInvitation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamInvitation",
      "kind": "LinkedField",
      "name": "teamInvitation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    }
  ],
  "type": "VerifiedInvitationPayload",
  "abstractKey": null
};

(node ).hash = "fff7cb9c7330c56ca3389427adbef1b4";

export default node;
